import { NgModule } from '@angular/core';
import { LibDownArrowIconComponent } from './lib-down-arrow-icon.component';

@NgModule({
  declarations: [LibDownArrowIconComponent],
  exports: [LibDownArrowIconComponent],
})
export class LibDownArrowIconModule {}
